// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Credit_mainContainer__1CPKG","btns":"Credit_btns__3y1FA","creditRemain":"Credit_creditRemain__1bCyt","modalContentContainer":"Credit_modalContentContainer__1JyQZ"};